<template>
    <div id="servicios">
        <div class="container">
            <h2 class="title-component">Servicios</h2>
            <div class="row">
                <div class="col-sm">
                    <h4>Desarrollo<br><i class="fas fa-code"></i></h4>
                    <span>Tu primera primera presencia en la web. Plantillas personalizadas o creación desde 0 de tu página</span>
                </div>
                <div class="col-sm">
                    <h4>Diseño<br><i class="fas fa-paint-brush"></i></h4>
                    <span>Descubrimos la identidad a tu marca. <br> Destacá sobre tu competencia y subí de nivel tus redes</span>
                </div>
                <div class="col-sm">
                    <h4>Consultoría<br><i class="fas fa-users"></i></h4>
                    <span>Campañas para que tu negocio crezca. <br> El poder de las redes sociales a tu servicio</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Servicios",
}
</script>

<style>
#servicios{
    background: #F9B256;
    padding: 0 0 20px 0;
}


</style>